import React, { useState } from 'react';
import { FaEnvelope, FaLock, FaUser, FaSignInAlt } from 'react-icons/fa';
import { IoMdClose } from "react-icons/io";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { FaArrowRight } from "react-icons/fa6";
import { Tab, Tabs } from 'react-bootstrap';
import { FormCheck } from "react-bootstrap";
import { FaCheckCircle, FaDownload } from "react-icons/fa";
const Certificate = () => {
  const [isModal, setModal] = useState('');
  const [activeTab, setActiveTab] = useState('life');
  return (
    <>
      {/* login model */}
      <div>
        <button type="button" className="btn btn-round btn-info" onClick={() => setModal('Vertically Centered')}>Vertically centered</button>
        <div
          className={`login_details_popup modal fade ${isModal === 'Vertically Centered' ? 'd-block show' : ''}`}>
          <div className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}  >
            <div className="modal-content rounded-4 shadow">
              <div className="modal-body">
                <div className='pb-2'>
                  <h5 className="modal-title fw-bold">Email Already Registered</h5>
                  <button type="button" className="btn-close" onClick={() => setModal('')} >
                    <IoMdClose size={18} />
                  </button>
                </div>
                <div className='pb-2'>
                  <p>The email address <strong>tamangang@yahoo.co.in</strong> is already associated with an account.
                    Please choose one of the following options:</p>
                </div>
                <Tabs defaultActiveKey="login" className="mb-3 nav-pills nav-fill ">
                  <Tab
                    eventKey="login"
                    title={<span><FaSignInAlt className="me-1" /> Login Instead</span>}>
                    <div className="form-group position-relative mb-3">
                      <label>Email</label>
                      <FaEnvelope className="form-icon" />
                      <input
                        type="email"
                        className="form-control ps-5"
                        value="tamangang@yahoo.co.in"
                        readOnly
                      />
                    </div>
                    <div className="form-group position-relative mb-3">
                      <label className='forget_flex'>
                        Password
                        <a href="#" className="float-end text-decoration-none">Forgot password?</a>
                      </label>
                      <FaLock className="form-icon" />
                      <input type="password" className="form-control ps-5" />
                    </div>
                  </Tab>
                  <Tab
                    eventKey="differentEmail"
                    title={
                      <span><FaUser className="me-1" /> Use Different Email</span>}>
                    <div className="form-group position-relative mb-3">
                      <label>Email</label>
                      <FaEnvelope className="form-icon" />
                      <input
                        type="email"
                        className="form-control ps-5"
                      />
                    </div>
                  </Tab>
                </Tabs>
              </div>
              <div className='pl-3 pr-3'>
                <button type="button" className="btn btn-primary w-100">
                  Login and Continue <FaArrowRight />
                </button>
              </div>
              <div className="modal-footer border-0 d-flex justify-content-between">
                <p> <i class="fa fa-question-circle"></i> Need Help</p>
                <button type="button" className="btn btn-outline-default" onClick={() => setModal('')}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* login model */}

      <div className="application_check">
        <div className="membership-container">
          {/* <div className="membership-header">
            <h1>AMASI Membership Application</h1>
            <p>Association of Minimal Access Surgeons of India</p>
          </div> */}
          <div className="membership-box">
            {/* <div className="membership-section">
              <h2>Life Members [LM] Application</h2>
              <p>Please review the eligibility criteria and required documents before proceeding</p>
            </div>
            <div className="membership-subsection">
              <h3>Eligibility Criteria:</h3>
              <ul>
                <li>
                  <label>
                    <FormCheck
                      type="checkbox"
                      label="A general surgeon practicing in India or SAARC Countries."
                    />
                  </label>
                </li>
                <li>
                  <label>
                    <FormCheck
                      type="checkbox"
                      label="Member of the ASI (Association of Surgeons of India)."
                    />
                  </label>
                </li>
              </ul>
            </div>

            <div className="membership-subsection">
              <h3>Documents Required:</h3>
              <ul>
                <li>
                  <label>
                    <FormCheck
                      type="checkbox"
                      label="Copy of PG degree certificate."
                    />
                  </label>
                </li>
                <li>
                  <label>
                    <FormCheck
                      type="checkbox"
                      label="Copy of ASI membership certificate. <span> Required for Life Membership. Without this, your application will be rejected.</span>"
                    />
                  </label>
                  <div>
                    <p className="bold"> Copy of NMC registration certificate.</p>
                    <p className="red">Required for Life Membership.</p>
                    <p>Without this, your application will be rejected.</p>
                  </div>
                </li>
                <li>
                  <label>
                    <FormCheck
                      type="checkbox"
                      label="Copy of NMC registration certificate."
                    />
                  </label>
                </li>
              </ul>
            </div> */}

            <div className="membership-alert">
              <HiOutlineExclamationCircle size={35} />
              <p>
                <strong>Important:</strong>   ASI membership certificate is mandatory for Life Membership. If you don't have an ASI certificate, please consider applying for Associate Life Membership instead.
              </p>
            </div>

            <div className="membership-actions">
              <div className="membership-tabs">
                <div className={`tab-option ${activeTab === 'life' ? 'active' : ''}`} onClick={() => setActiveTab('life')}>
                  Life Member
                </div>
                <div className={`tab-option ${activeTab === 'associate' ? 'active' : ''}`} onClick={() => setActiveTab('associate')}>
                  Associate Life Member
                </div>
              </div>
              <div className='login_details_popup'>
                <button className="btn btn-primary ">
                  Proceed <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* login model */}

      {/* aapplication success */}
      <div className='application_div_page'>

        <div className="application-success">
          <div className="success-icon">
            <FaCheckCircle />
          </div>
          <h1>Application Submitted Successfully</h1>
          <div className="summary-box">
            <div className="summary-header">
              <h2>Application Summary</h2>
              <span className="reference">
                Reference: <strong>APP12345</strong><i class="fa fa-copy"></i>
              </span>
            </div>

            <p className="greeting">
              Dear <strong>Dr. John Doe</strong>,
            </p>
            <p>
              We are pleased to confirm that we have received your AMASI membership application with payment receipt attached.
            </p>
            <p>
              Our team will review your application and respond within 24 hours. You can check your application status using the track button below or directly on our website using your reference number.
            </p>

            <div className="info-box">
              <div className="info-item">
                <label>Membership Type</label>
                <p><strong>ASSOCIATE LIFE MEMBER [ALM]</strong></p>
              </div>
              <div className="info-item">
                <label>Submission Date</label>
                <p><strong>3/13/2025</strong></p>
              </div>
            </div>

            <div className="payment-box">
              <h3>Payment Details</h3>
              <div className="payment-row">
                <span>Base Amount</span>
                <strong>₹3,500</strong>
              </div>
              <div className="payment-row">
                <span>GST (18%)</span>
                <strong>₹630</strong>
              </div>
              <div className="payment-row total">
                <span>Total Amount</span>
                <strong>₹4,130</strong>
              </div>
              <div className="receipt-row">
                <span>Receipt sent to john.doe@example.com</span>
                <button className="download-btn">
                  <FaDownload /> Download Receipt
                </button>
              </div>
            </div>

            <div className="info-note">
              <strong>Payment Receipt:</strong> A copy of your payment receipt has been emailed to <span>john.doe@example.com</span>. If you don’t see it in your inbox, please check your spam or junk folder.
            </div>

            <div className="warning-note">
              <strong>Important Note:</strong> Applications that do not fulfill the eligibility criteria will be rejected. Only the application fee will be refunded (GST refund is subject to policy).
            </div>

            <div className="action-buttons login_details_popup ">
              <button className="btn btn-primary ">TRACK STATUS</button>
              <button className="btn btn-outline-default">Visit Website</button>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Certificate;
